// extracted by mini-css-extract-plugin
module.exports = {"hot-swap-cont":"style_hot-swap-cont__2YbPH","hot-swap-wrap":"style_hot-swap-wrap__181p_","hot-swap-ratio":"style_hot-swap-ratio__FjXok"};